// const API_BASE_URL = process.env.REACT_APP_API_URL;

// export const getSnappers = async () => {
//   try {
//     const storedUser =
//       localStorage.getItem("user") || localStorage.getItem("localUser");
//     const user = JSON.parse(storedUser || "{}");
//     const userId = user?.id;

//     if (!userId) {
//       throw new Error("User ID not found. Please login again.");
//     }

//     const response = await fetch(`${API_BASE_URL}/api/snapper-list`, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         "X-User-Id": String(userId),
//       },
//     });

//     if (!response.ok) {
//       const errorText = await response.text();
//       throw new Error(
//         `Failed to fetch snappers: ${response.status} ${errorText}`
//       );
//     }

//     return await response.json();
//   } catch (error) {
//     console.error("getSnappers error:", error);
//     throw error;
//   }
// };

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getSnappers = async ({
  page = 1,
  limit = 50,
  search = "",
  city = "",
  status = "",
  activeJob = "",
} = {}) => {
  try {
    const storedUser =
      localStorage.getItem("user") || localStorage.getItem("localUser");
    const user = JSON.parse(storedUser || "{}");
    const userId = user?.id;

    if (!userId) {
      throw new Error("User ID not found. Please login again.");
    }

    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search || "",
      city: city || "",
      status: status || "",
      active_job: activeJob || "",
    });

    const response = await fetch(
      `${API_BASE_URL}/api/snapper-list?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-User-Id": String(userId),
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Failed to fetch snappers: ${response.status} ${errorText}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error("getSnappers error:", error);
    throw error;
  }
};